<template>
  <div id="app">
    <router-view></router-view>
    <link href="https://fonts.googleapis.com/css?family=Arvo" rel="stylesheet">
  </div>
</template>

<script>
export default {
  name: 'app',
  components: {}
}
</script>

<style>
/*colors:
blue: #14A0C5
yellow: #fff133
pink:  #ff0043*/



@font-face {
    font-family: comfortaa;
    src: url(../static/fonts/comfortaa/Comfortaa-Regular.ttf);
}

@font-face {
    font-family: comfortaaLight;
    src: url(../static/fonts/comfortaa/Comfortaa-Light.ttf);
}

@font-face {
    font-family: cheque;
    src: url(../static/fonts/cheque/Cheque-Black.otf);
}


@font-face {
    font-family: raleway;
    src: url(../static/fonts/raleway-master/Raleway.otf);
}


@font-face {
    font-family: john;
    src: url(../static/fonts/BIGJOHN.otf);
}


@font-face {
    font-family: joe;
    src: url(../static/fonts/SlimJoe.otf);
}


@font-face {
    font-family: dosis;
    src: url(../static/fonts/Dosis/Dosis-Regular.ttf);
}

@font-face {
    font-family: josefin;
    src: url(../static/fonts/Josefin_Sans/JosefinSans-Regular.ttf);
}
@font-face {
    font-family: noto;
    src: url(../static/fonts/Noto_Sans/NotoSans-Regular.ttf);
}

h1 {
  padding-left: 0;
  color: #d47b40;
  font-family: joe;
  cursor: default;
  text-align: center;
   width: 100%;
   font-size: 5em!important;
   margin-bottom: 5em;
}

p, a, h2, h3, h4, h5, strong {
  font-family: raleway;
  cursor: default;
}

h2 {
  color: #d47b40;
  text-align: center;
}


a {
  text-decoration: none;
  margin-bottom: 0.5em;
}

a:hover {
  color: #54ADB2;
  padding-bottom: 0.3em;
  border-bottom: 2px #d47b40 solid;
  cursor: pointer;

}

p, a, strong {
  color: black;
}

strong {
  font-weight: inherit;
}
.parallax {
    margin-left: -1em;
    height: 50vh;
    width: 100vw;

    background-attachment: fixed;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

/* #home, #infos, #staff, #philosophy, #services {
  width: 100%;
} */


@media (pointer:coarse) {
  #app {
    width: 100vw;
  }
  .container {
    max-width: 100%;
    padding: 0;
  }


  h2 {
    font-size: 3em;
  }


  h3 {
    font-size: 1.5em;
  }

  p, a {
    font-size: 1.3em;
  }
}

@media (pointer:fine) {
  #app {
    width: 100%;
  }

  .container {
    width: 80vw;
    margin: auto;
    text-align: center;
    padding: 5em;
  }

  h1 {

  }

  h2 {
    font-size: 4em;
  }


  h3 {
    font-size: 2.5em;
  }

  p, a {
    font-size: 1.6em;
  }
}

</style>



// WEBPACK FOOTER //
// App.vue?3b900b04